import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Box, Container, GlobalStyles } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import NavBar from './NavBar';
import SignupCallToAction from './SignupCallToAction';
import { ToolButton } from './ToolCard';

export default function PublicToolsLayout() {
  const location = useLocation();
  return (
    <>
      <NavBar publicOnly />
      <GlobalStyles styles={{ body: { paddingBottom: 32 } }} />
      <Container component="main" maxWidth="lg" sx={{ pt: { xs: 1, md: 2 }, pb: { xs: 3, md: 5 } }}>
        {!/^\/tools\/?$/.test(location.pathname) && (
          <Box sx={{ mb: 3 }}><ToolButton component={Link} to="/tools" startIcon={<ArrowLeft size={17} aria-hidden="true" />}>
            All tools
          </ToolButton></Box>
        )}
        <Outlet />
        <SignupCallToAction />
      </Container>
    </>
  );
}
